<div class="section-currency section-topup p-3 bg-white mt-4">
  <h5
    class="section-wallet-heading.select-payment-method"
    i18n="@@wallet-topup-payment.select-payment-method"
  >
    STEP 2 : SELECT PAYMENT METHOD
  </h5>
  <p
    class="section-wallet-subheading mt-4"
    i18n="@@wallet-topup-payment.your-payment-method"
  >
    YOUR PAYMENT METHODS
    <span
      caiPopover
      [enablePopover]="true"
      [target]="idTooltip"
      [allowHoverOnTarget]="true"
      [placement]="'right-start'"
      class="tooltip-top-index"
      role="button"
    >
      <span class="icon-set">
        <img
          alt="info icon"
          src="/assets/media/icons/search-results/info.svg"
        />
      </span>
      <ng-template #idTooltip>
        <kt-popover
          [arrowColor]="'#679EC6'"
          [bgColor]="'#679EC6'"
          [textColor]="'white'"
          [placement]="'right-start'"
          [messageHtml]="paymentMethodTooltip"
          style="max-width: 255px !important"
        >
        </kt-popover>
      </ng-template>
    </span>
  </p>
  <div class="payment-methods-wrapper d-flex flex-wrap">
    <div
      class="payment-methods d-flex align-items-center p-2 ms-2"
      role="button"
      [ngClass]="[
        !walletTopUp.currency ||
        (walletDetails?.provider === 'currencycloud' &&
          (!localBanksAllowedCurrency.includes(walletTopUp.currency) ||
            !hasLocalBank)) ||
        (!isLocalEnabled && walletDetails?.provider === 'tazapay')
          ? 'disabled'
          : '',
        walletTopUp.paymentMethod == WalletTopupPaymentTypeEnum.LOCAL_BANK
          ? 'active'
          : '',
      ]"
      (click)="onSelectPaymentMethod(WalletTopupPaymentTypeEnum.LOCAL_BANK)"
    >
      <img
        src="/assets/media/icons/wallet/localBankTransfer.svg"
        alt="localBankTransfer"
      />
      @if (isTazaPay) {
        <p class="ms-2 mb-0" i18n="@@wallet-topup-payment.bank-transfer">
          BANK TRANSFER
        </p>
      }
      @if (!isTazaPay) {
        <p class="ms-2 mb-0" i18n="@@wallet-topup-payment.bank-local-transfer">
          LOCAL BANK<br />TRANSFER
        </p>
      }
    </div>
    <div
      class="payment-methods d-flex align-items-center p-2 ms-2"
      role="button"
      (click)="
        onSelectPaymentMethod(WalletTopupPaymentTypeEnum.INTERNATIONAL_BANK)
      "
      [ngClass]="{
        active:
          walletTopUp.paymentMethod ==
          WalletTopupPaymentTypeEnum.INTERNATIONAL_BANK,
        disabled:
          walletDetails?.provider === 'currencycloud'
            ? !hasInternationalBank
            : !isInternationEnabled,
      }"
    >
      <img src="/assets/media/icons/wallet/swiftBank.svg" alt="swiftBank" />
      <p
        class="ms-2 mb-0"
        i18n="@@wallet-topup-payment.international-bank-transfer"
      >
        INTERNATIONAL<br />BANK TRANSFER
      </p>
    </div>
    <div
      class="payment-methods d-flex align-items-center p-2 ms-2"
      role="button"
      (click)="onSelectPaymentMethod(WalletTopupPaymentTypeEnum.CREDIT_CARD)"
      [ngClass]="{
        disabled: !isCreditCardEnabled,
        active:
          walletTopUp.paymentMethod == WalletTopupPaymentTypeEnum.CREDIT_CARD,
      }"
    >
      <img src="/assets/media/icons/wallet/creditCard.svg" alt="creditCard" />
      <p class="ms-2 mb-0" i18n="@@wallet-topup-payment.cards">CARDS</p>
      <img
        src="/assets/media/icons/wallet/visa-card.svg"
        class="mx-1"
        alt="visaCard"
      />
      <img src="/assets/media/icons/wallet/master-card.svg" alt="masterCard" />
    </div>
    <div
      class="payment-methods d-flex align-items-center p-2 ms-2"
      role="button"
      (click)="onSelectPaymentMethod(WalletTopupPaymentTypeEnum.OTHER)"
      [ngClass]="{
        disabled: !isOtherEnabled,
        active: walletTopUp.paymentMethod == WalletTopupPaymentTypeEnum.OTHER,
      }"
    >
      <p class="mb-0 ms-2" i18n="@@wallet-topup-payment.local-payment-methods">
        LOCAL PAYMENT METHODS
      </p>
    </div>
  </div>
  @if (
    walletTopUp.paymentMethod !== WalletTopupPaymentTypeEnum.CREDIT_CARD &&
    walletDetails?.provider !== "tazapay" &&
    walletTopUp.paymentMethod !== WalletTopupPaymentTypeEnum.OTHER
  ) {
    <div>
      <p class="section-wallet-subheading mt-4">ACCOUNT & BANK DETAILS :</p>
      <div class="pe-5">
        <div class="d-flex align-items-center mt-3">
          <label
            for="accountHolderName"
            class="text-nowrap control-label"
            i18n="@@wallet-topup-payment.account-holder-name"
            >Account Holder Name</label
          >
          <p
            id="accountHolderName"
            class="form-control custom-control py-0 mb-0 d-flex align-items-center"
          >
            {{ selectedBank?.account_holder_name }}
          </p>
        </div>
        <div class="d-flex align-items-center mt-3">
          <label for="accountNumber" class="text-nowrap control-label">{{
            walletTopUp.paymentMethod ==
            WalletTopupPaymentTypeEnum.INTERNATIONAL_BANK
              ? "IBAN"
              : (paymentDetailsLabel[WalletTopupPaymentTypeEnum.LOCAL_BANK][
                  walletTopUp.currency
                ]?.acnumber ?? "Account Number")
          }}</label>
          <p
            id="accountNumber"
            class="form-control custom-control py-0 mb-0 d-flex align-items-center"
          >
            {{ selectedBank?.account_number }}
          </p>
        </div>
        <div class="d-flex align-items-center mt-3">
          <label for="achRoutingNumber" class="text-nowrap control-label">{{
            walletTopUp.paymentMethod ==
            WalletTopupPaymentTypeEnum.INTERNATIONAL_BANK
              ? "BIC"
              : (paymentDetailsLabel[WalletTopupPaymentTypeEnum.LOCAL_BANK][
                  walletTopUp.currency
                ]?.acrouting ?? "ACH Routing Number")
          }}</label>
          <p
            id="achRoutingNumber"
            class="form-control custom-control py-0 mb-0 d-flex align-items-center"
          >
            {{ selectedBank?.routing_code }}
          </p>
        </div>
        <div class="d-flex align-items-center mt-3">
          <label
            for="bankName"
            class="text-nowrap control-label"
            i18n="@@wallet-topup-payment.bank-name"
            >Bank Name</label
          >
          <p
            id="bankName"
            class="form-control custom-control py-0 mb-0 d-flex align-items-center"
          >
            {{ selectedBank?.bank_name }}
          </p>
        </div>
        <div class="d-flex align-items-center mt-3">
          <label
            for="bankAddress"
            class="text-nowrap control-label"
            i18n="@@wallet-topup-payment.bank-address"
            >Bank Address</label
          >
          <p
            id="bankAddress"
            class="form-control custom-control py-0 mb-0 d-flex align-items-center"
          >
            {{ selectedBank?.bank_address }}
          </p>
        </div>
        <div class="d-flex align-items-center mt-3 mb-4">
          <label
            for="bankCountry"
            class="text-nowrap control-label"
            i18n="@@wallet-topup-payment.bank-country"
            >Bank Country</label
          >
          <p
            id="bankCountry"
            class="form-control custom-control py-0 mb-0 d-flex align-items-center"
          >
            {{ selectedBank?.bank_country }}
          </p>
        </div>
      </div>
    </div>
  }
</div>
